import { getIsSeller } from '@app/ducks';
import { getHomepageSlugForBuyer } from '@app/services/homepageRepository';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  buyerId: string;
  refetchOnMount?: boolean;
  enabled?: boolean;
}

export const BUYER_HOMEPAGE_QUERY_KEY = 'buyerHomepage';

export const useBuyerHomepage = ({ refetchOnMount, buyerId, enabled }: Props) => {
  const { t } = useTranslation(['cms']);
  const isSeller = useSelector(getIsSeller);

  return useQuery({
    enabled,
    meta: {
      errorMessage: t('cms:fetch_homepage_fail'),
    },
    queryFn: async () => getHomepageSlugForBuyer(isSeller ? buyerId : undefined),
    queryKey: [BUYER_HOMEPAGE_QUERY_KEY, { buyerId, isSeller }],
    refetchOnMount,
  });
};
